import Icon from '@/common/components/Icon';
import moment from 'moment';
import { REFUND_STATUSES, REFUND_REASONS } from '@/common/constants/refunds';

export const getRows = (refunds, currency, downloadPdf, loadingFiles) =>
	refunds.map((refund, index) => (
		<tr
			style={{ borderTop: '1px solid lightgrey' }}
			key={refund._id}
		>
			<td style={{ textAlign: 'center' }}>{index + 1}</td>
			<td style={{ textAlign: 'center' }}>
				{refund.amount} {currency}
			</td>
			<td style={{ textAlign: 'center' }}>
				{REFUND_STATUSES.find((status) => status.value === refund.status)?.label}
			</td>
			<td style={{ textAlign: 'center' }}>
				{REFUND_REASONS.find((reason) => reason.value === refund.reason)?.label}
			</td>
			<td style={{ textAlign: 'center' }}>
				{refund.comment ? refund.comment : 'No comment'}
			</td>
			<td style={{ textAlign: 'center' }}>
				{moment(refund.created_at).format('DD.MM.YYYY')}
			</td>
			<td style={{ textAlign: 'center' }}>
			{refund.files.map((file) =>
				loadingFiles.includes(file) ? (
					<Icon key={file} onClick={() => false} name='spinner' spin />
				) : (
					<Icon key={file} name="file-pdf" onClick={() => downloadPdf(file)} />
				),
			)}
			</td>
		</tr>
	));
